/**
 * How an organization knowledge file is named on screen: its first "# " heading when it has one,
 * otherwise its file name in words ("pricing-policy.md" -> "Pricing policy").
 */
const describeKnowledgeFile = ({ path, content = null }) => {
  const heading = String(content || '')
    .split('\n')
    .find((line) => line.startsWith('# '));

  if (heading) {
    return heading.slice(2).trim();
  }

  const name = String(path || '')
    .split('/')
    .pop()
    .replace(/\.(md|markdown|txt)$/i, '')
    .replace(/[-_]+/g, ' ')
    .trim();

  return name ? name.charAt(0).toUpperCase() + name.slice(1) : 'Untitled';
};

export default describeKnowledgeFile;
